import { RxPlus } from "react-icons/rx";

import { Tooltip, TooltipContent, TooltipTrigger } from "@sorcery/ui";

import { ModalTypeEnum, useModal } from "~/providers/ModalProvider";

export const CreateDeck = () => {
  const { openModal } = useModal();

  return (
    <div className="group/create-deck px-1">
      <Tooltip>
        <TooltipTrigger>
          <RxPlus
            size={17}
            className={
              "mt-2 transition duration-150 ease-in-out group-hover/create-deck:opacity-60"
            }
            onClick={() => openModal(ModalTypeEnum.CREATEDECK)}
          />
        </TooltipTrigger>
        <TooltipContent>
          <p>Create Deck</p>
        </TooltipContent>
      </Tooltip>
    </div>
  );
};
